// Batch 27 · Add-on 3 · C (M41) — an open tab keeps running the build it was loaded with. The build writes build-id.json next
// to index.html (craco.config.js, served no-cache); the tab compares it with its own id on window focus, every 10 minutes and
// after any 404 from the API (an unknown route is the usual sign of a newer server), and says so — it never reloads by itself.
import { BUILD_ID } from "@/lib/pwa";

export const CHECK_EVERY_MS = 10 * 60 * 1000;
export const API_404_EVENT = "af-api-404";
let last = 0;

export async function serverBuildId(fetchFn = (typeof fetch !== "undefined" ? fetch : null)) {
  if (!fetchFn) return "";
  try {
    const r = await fetchFn(`/build-id.json?ts=${Date.now()}`, { cache: "no-store" });
    if (!r || !r.ok) return "";
    const j = await r.json();
    return String((j && j.build_id) || "");
  } catch { return ""; }
}

/** True when the server serves a different build than this tab runs. A dev build ("dev") never reports a new version. */
export async function newVersionAvailable({ mine = BUILD_ID, fetchFn, now = Date.now(), minGapMs = 15000 } = {}) {
  if (!mine || mine === "dev") return false;
  if (now - last < minGapMs) return null;              // throttled (focus + 404 can fire together)
  last = now;
  const srv = await serverBuildId(fetchFn);
  return !!srv && srv !== mine;
}
export function _resetBuildCheck() { last = 0; }
